import { FilterTypes } from '../../../models/filterEnums.model';
import { RegularExpressionPattern } from '../../../shared/_constants';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class IdentificationNumbersCriteria extends FilterCriteria {
  public override title = 'Identification Numbers';
  public override type: FilterTypes = FilterTypes.IdentificationNumber;
  public override bvdId: string = null;

  public override validate(): boolean {
    if (this.bvdId === null) {
      return false;
    }
    const match = this.bvdId.match(RegularExpressionPattern.BvdIdPattern);
    if (match === null || !match.includes(this.bvdId)) {
      return false;
    }
    this.bvdId = this.bvdId.toUpperCase();
    return true;
  }

  public override toString(): string {
    return 'ID Number: ' + this.bvdId;
  }
}
